export default function Logo() {
  return <span className="brand"><span className="brand-mark" aria-hidden="true"><i /><i /><i /></span><span>perform<span className="brand-period">.</span></span></span>;
}